module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('measurementUnitdialog', {
    ref: "unitdialog"
  })], 1), _vm._v(" "), _c('measurementUnitList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-account": _vm.editMeasurementUnit
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e6c5834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/MeasurementUnit.vue
// module id = 2217
// module chunks = 0